import { mutationsBuilder, mutationFormat, cache_state } from '@u/vuexHelper';

let state = new cache_state();
//@mix/VuexCache
const cacheObj = JSON.parse(localStorage.getItem('VUEX_CACHE'));
if (cacheObj != null && typeof cacheObj === 'object' && Object.keys(cacheObj).length) {
	for (let key in state) {
		if (typeof cacheObj[key] !== 'undefined') {
			state[key] = cacheObj[key];
		}
	}
}
const mutations = mutationsBuilder(state);
//refreshTokenID => REFRESH_TOKEN_I_D
mutations['SET_REFRESH_TOKEN_ID'] = mutations[mutationFormat('refreshTokenID')];
export default {
	namespaced: true,
	state,
	mutations,
};
